// DialogApproveEstimate Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import EstimateDocumentUpload from '../../estimate/estimate_docuementupload/estimate_docuementupload.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import currency from '../../../lib/currency.jsx'
import { Spinner } from '../../../common/common/spinner.jsx'

class DialogApproveEstimate extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      showError: false,
      refNumber: '',
      approveDate: '',
      file: null,
      total: '',
      contactName: '',
      dataDate: null,
      loading: {
        isApproving: false
      }
    }
    this._references = {
      referenceNumber: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null
    }
  }

  show (estimate) {
    FabButtonManager.setVisible(false)
    if (estimate) {
      this.setState({
        refNumber: '',
        approveDate: estimate.reviewedOn
          ? new Date(estimate.reviewedOn)
          : new Date(),
        total: estimate.total,
        contactName: estimate.contactName,
        dataDate: new Date()
      })
    }
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      showError: false,
      refNumber: '',
      approveDate: '',
      total: '',
      contactName: '',
      dataDate: null,
      file: null
    })
  }

  toggleLoading (key, isLoading) {
    this.setState(prevState => ({ ...prevState, loading: { ...prevState.loading, [key]: isLoading } }))
  }

  isActive () {
    return this.state.active
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  };

  render () {
    const { loading: { isApproving } } = this.state
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'
    return (
      <Dialog active={this.state.active} onClose={this.hide.bind(this)}>
        <div className='dialog-form estimateapprove-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='estimate.form.approveEstimateTitle' />
                <span className='subinfo' />
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='estimate.form.estimateEditErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection sectionleft'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='refNumber'
                          value={this.state.refNumber}
                          label='estimate.form.labelPoNumber'
                          ref={this._references.referenceNumber}
                          size={10}
                          maxLength={100}
                          styleDotted
                          onChange={this._onChangeInput.bind(this, 'refNumber')}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <FormDatePicker
                          label='estimate.form.estimateApproveDate'
                          placeholder='estimate.form.estimateApproveDate'
                          value={this.state.approveDate}
                          name='approveDate'
                          onChange={this._onChangeInput.bind(
                            this,
                            'approveDate'
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <span className='splitter' />
                  <div className='formsection sectionright'>
                    <EstimateDocumentUpload
                      fileObj={this.state.file}
                      uploadSuccess={this._onUploadDocument.bind(this)}
                      onDeleteClick={this._onDeleteDocument.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon={!isApproving ? 'common-success-tick' : undefined}
              title='estimate.form.editEstimateSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            >
              {isApproving ? <Spinner size={28} color='#fff' /> : null}
            </IconButton>
          </div>
          <div className='dialogform-footer'>
            <div className='formrow'>
              <div className='formcol'>
                <div className='totalinfo'>
                  <span className='title'>
                    <IntlMessage ident='estimate.form.titlePriceExcl' />
                  </span>
                  <div className='content'>
                    <h2 className='infovalue'>
                      {this.state.total
                        ? currency.formatSymbol(this.state.total)
                        : '-'}
                    </h2>
                  </div>
                </div>
              </div>
              <div className='formcol'>&nbsp;</div>
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (ev) {
    ev.preventDefault()
    let noErrors = 0
    this.toggleLoading('isApproving', true)

    if (
      this._references.referenceNumber.current &&
      !this._references.referenceNumber.current.validate()
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      const estObj = {
        referenceNumber: this.state.refNumber,
        reviewedOn: this.state.approveDate,
        status: 'Approved',
        file: this.state.file
      }

      if (this.props.onSubmit) {
        this.props.onSubmit(estObj, () => {
          this.toggleLoading('isApproving', false)
        })
      }
    } else {
      this.setState({ showError: true, loading: { isApproving: false } })
    }
  }

  _onUploadDocument (file, message, _e) {
    this.setState({
      file: { fileName: message.id, fileDisplayName: file.name }
    })
  }

  _onDeleteDocument () {
    this.setState({ file: null })
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }
}

export default DialogApproveEstimate
